/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Form, Card, Alert, Spinner, Button, Row, Col } from 'react-bootstrap';
import Axios from 'axios';
import Input from './common/Input';
import { useForm } from 'react-hook-form';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useHistory } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useRazorpay } from "react-razorpay";

const PayMembershipFees = (props) => {

    const { Razorpay } = useRazorpay();

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const history = useHistory();
    const { register, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur'
    });

    const [clientName, setClientName] = useState('');
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('danger');
    const [owner, setOwner] = useState({});
    const [membershipFees, setMembershipFees] = useState(0);
    const [amount, setAmount] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);

    const updateMembershipDate = () => {
        Axios.post('update-membership-date', { itemId: coreContext.client.id, ownerId: authContext.ownerId });
    }

    const createOrder = () => {
        setIsProcessing(true);
        setMessage('Generating secure payment order, please wait...');
        setMessageType('info');

        Axios.post('/create-order', { amount, currency: 'INR', receipt: 'receipt#2', notes: { ptype: 'fees' } }).then(response => {
            if (response.data.id) {
                handlePayment(response.data.id);
                setMessage('Payment completed successfully! You can check details in My Renewals on home page.');
                setMessageType('success');
                updateMembershipDate();
            } else {
                setIsProcessing(false);
                setMessage('Error generating order, please try again later.');
                setMessageType('danger');
            }
        }).catch(err => {
            setIsProcessing(false);
            console.error('Error generating order:', err);
            setMessage('Error generating order, please try again later.');
            setMessageType('danger');
        });
    };

    const recordPayment = (paymentId) => {
        Axios.post('/record-event-payment', {
            itemId: authContext.itemId,
            eventId: 0,
            amount,
            paymentId,
            comment: 'Payment for Vyavastha Shulk',
        }).then(response => {
            setIsProcessing(false);
            setAmount('');
            const value = response.data.message;
            setMessage(value || 'Payment recorded successfully!');
            setMessageType('success');
        }).catch(err => {
            setIsProcessing(false);
            const value = err.response && err.response.data && err.response.data.data;
            if (value && value[0] && value[0].msg) {
                setMessage(value[0].msg);
            } else {
                setMessage('Error recording payment, please try again later.');
            }
            setMessageType('danger');
        });
    };

    const handlePayment = (id) => {
        const options = {
            key: "rzp_live_TZ8r4C3jFitOCQ",
            amount: amount,
            currency: "INR",
            name: clientName || coreContext.client.item_name || "Swabhiman Member",
            description: "Payment for Annual Vyavastha Shulk",
            order_id: id,
            handler: (response) => {
                setMessage("Payment Successful! Recording transaction...");
                setMessageType('success');
                recordPayment(response.razorpay_payment_id);
            },
            prefill: {
                name: coreContext.client.item_name ? coreContext.client.item_name : "Swabhiman User",
                email: coreContext.client.item_email ? coreContext.client.item_email : "swabhimanjnv@gmail.com",
                contact: coreContext.client.item_contact ? coreContext.client.item_contact : "9999999999",
            },
            theme: {
                color: "#1e40af",
            },
        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();
    };

    const fetchOwner = () => {
        Axios.get('/self', { params: { itemId: authContext.ownerId } }).then(response => {
            setOwner(response.data.client);
            const fee = response.data.client.membership_fees || 1000;
            setMembershipFees(fee);
            setAmount(fee);
            setUploadButtonDisabled(false);
        }).catch(err => { console.error(err); });
    }

    useEffect(fetchOwner, []);

    const changeAmount = (e) => {
        setMessage('');
        var val = e.target.value;
        setAmount(val);
        if (parseInt(val, 10) >= parseInt(membershipFees, 10)) {
            setUploadButtonDisabled(false);
        } else {
            setUploadButtonDisabled(true);
            setMessage('Amount should be at least ₹' + membershipFees + ' to pay Vyavastha Shulk.');
            setMessageType('warning');
        }
    }

    return (
        <div className="container py-4">
            <Row className="justify-content-center">
                <Col lg={6} md={8}>
                    <Card className="shadow">
                        <Card.Header className="text-center py-3">
                            <h4 className="mb-0 font-weight-bold" style={{ color: '#1e3a8a' }}>
                                💳 Pay Vyavastha Shulk (Membership Fees)
                            </h4>
                        </Card.Header>
                        <Card.Body className="p-4">
                            {coreContext.client.item_name && (
                                <div className="p-3 mb-4 bg-light rounded border d-flex justify-content-between align-items-center">
                                    <div>
                                        <div className="text-muted small">Paying for Member</div>
                                        <strong>{coreContext.client.item_name}</strong>
                                    </div>
                                    <Badge bg="primary">{coreContext.client.smst_category || 'Alumni'}</Badge>
                                </div>
                            )}

                            {message && (
                                <Alert variant={messageType} className="py-2">
                                    {message}
                                </Alert>
                            )}

                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Enter Amount (₹ INR)</strong></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={amount}
                                        onChange={changeAmount}
                                        placeholder="Enter amount"
                                        min={membershipFees || 1}
                                        required
                                    />
                                    <Form.Text className="text-muted">
                                        Standard annual contribution fee: <strong>₹{membershipFees || 1000}</strong>
                                    </Form.Text>
                                </Form.Group>

                                <div className="d-grid gap-2 mt-4">
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        onClick={createOrder}
                                        disabled={uploadButtonDisabled || isProcessing}
                                        className="font-weight-bold py-2"
                                    >
                                        {isProcessing ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                                Processing Secure Checkout...
                                            </>
                                        ) : (
                                            `Proceed to Pay ₹${amount || 0}`
                                        )}
                                    </Button>
                                </div>

                                <div className="text-center text-muted small mt-3">
                                    🔒 Secured with 256-bit SSL encryption & Razorpay
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={true}
                type='success'
            />
        </div>
    );
}

export { PayMembershipFees };